import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { StyledIconButtonProps } from './types';

export const iconButtonStyles = css<StyledIconButtonProps>`
  ${({ $isSecondary, $isActive }) =>
    $isSecondary
      ? css`
          width: 2.25rem;
          height: 2.25rem;
          border-radius: var(--r-sm);
          border: none;
          color: ${$isActive ? 'var(--brand-ink)' : 'rgba(9,15,56,0.54)'};
          background-color: ${$isActive ? 'var(--paper-2)' : 'transparent'};
        `
      : css`
          width: 2.5rem;
          height: 2.5rem;
          border-radius: var(--r-sm);
          border: 1px solid rgba(9, 15, 56, 0.15);
          background-color: var(--surface);
          color: rgba(9, 15, 56, 0.54);
        `}
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
  &:disabled,
  &[disabled] {
    pointer-events: none;
    opacity: 0.3;
  }
  &:hover {
    color: var(--brand-ink);
    background-color: var(--paper-2);
    border-color: ${({ $isSecondary }) =>
      $isSecondary ? 'transparent' : 'var(--line-2)'};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.small};
  }
  &:active {
    transform: translateY(0);
    background-color: var(--line);
  }
  svg {
    width: 1em;
    height: 1em;
    font-size: 1.5rem;
    fill: currentColor;
  }
`;

export const StyledIconButton = styled.button<StyledIconButtonProps>`
  ${iconButtonStyles}
`;

export const StyledIconButtonLink = styled(Link)<StyledIconButtonProps>`
  ${iconButtonStyles}
  text-decoration: none;
`;
